









































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { MessageDetail } from '@/modules/message';
import { AttachmentFile } from '@/models/attachmentFile';
import { ReadTypes } from '@/enums/readTypes';
import { PublicTypes } from '@/enums/publicTypes';
import { ReturnTypes } from '@/enums/returnTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import 'quill/dist/quill.core.css';

interface Student {
  id: string;
  name: string;
  messageRead: boolean;
  commentCount: number;
}

@Component
export default class MessageDetails extends AvaivaledVue {
  private ReadTypes = ReadTypes;
  private PublicTypes = PublicTypes;
  private ReturnTypes = ReturnTypes;

  @Prop() private messageId: string;

  private uploadFilePreview = {
    visible: false,
    title: '',
    filePath: '',
    fileRaw: {},
  };

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get message(): MessageDetail {
    return this.$store.state.message.selectedMessage;
  }

  get attachments(): AttachmentFile[] {
    if (!this.message) {
      return [];
    } else {
      return this.message.attachmentList.filter((file) => !file.isDelete);
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Message);
  }

  private async loadData() {
    try {
      await this.$store.dispatch('message/selectMessage', this.messageId);
    } catch (error) {
      //
    }

    if (!this.message) {
      this.$router.push({
        name: 'MessageList',
      });
    }
  }

  private async onPreviewUploadFile(file: AttachmentFile) {
    const result = await this.$store.dispatch('file/setAttachmentFileInfo', file);
    if (!result) { return; }

    if (!!file.localUrl) {
      if (!!file.raw && /^image\//.test(file.raw.type)) {
        this.uploadFilePreview.title = file.name;
        this.uploadFilePreview.filePath = file.localUrl;
        this.uploadFilePreview.fileRaw = file.raw;
        this.uploadFilePreview.visible = true;
      } else {
        const fileName = file.name;
        if (!(window.navigator as any).msSaveOrOpenBlob) {
          const link = document.createElement('a');
          link.href = file.localUrl as string;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (!!file.raw) {
          const url = (window.navigator as any).msSaveOrOpenBlob(file.raw, fileName);
        }
      }
    }
  }

  private quoteMessage() {
    this.$router.push({
      name: 'MessageQuote',
      params: {
        messageId: this.messageId
      }
    });
  }

  private editMessage() {
    this.$router.push({
      name: 'MessageEdit',
      params: {
        messageId: this.messageId
      }
    });
  }

  private async deleteMessage() {
    try {
      await this.$confirm('メッセージを削除します。よろしいですか？', 'メッセージ削除', {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('message/deleteMessage', this.messageId);
      this.$router.push({ name: 'MessageList' });
      this.$notify({
        title: 'メッセージ削除完了',
        message: 'メッセージを削除しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      await this.$store.dispatch('message/deleteMessage', this.messageId);
      this.$notify.error({
        title: 'メッセージ削除エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private viewComment(student: Student) {
    this.$router.push({
      name: 'CommentView',
      params: {
        messageId: this.messageId,
        studentId: student.id
      }
    });
  }
}
